export default [
  {
    path: '/eoir-case-info',
    name: 'eoir-case-info',
    props: true,
    meta: { requiresAuth: true, title: 'EOIR Case Monitoring - Innovation Law Lab Platform' },
    component: () => import('@/views/EOIRCaseInfo.vue'),
  },
  {
    path: '/eoir-case-info/:id',
    name: 'eoir-case-info-view',
    props: true,
    meta: { requiresAuth: true, title: 'EOIR Case Viewer - Innovation Law Lab Platform' },
    component: () => import('@/views/EOIRCaseInfoViewer.vue'),
  },
]
